import { render } from "./LockExtensionLanding.vue?vue&type=template&id=5ff86ee1&scoped=true"
import script from "./LockExtensionLanding.vue?vue&type=script&lang=js"
export * from "./LockExtensionLanding.vue?vue&type=script&lang=js"

import "./LockExtensionLanding.vue?vue&type=style&index=0&id=5ff86ee1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff86ee1"]])

export default __exports__